import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import pxToRem from "assets/theme/functions/pxToRem";

const { borderRadius } = borders;

const sidenav = {
  styleOverrides: {
    root: {
      width: pxToRem(256),
      whiteSpace: "nowrap",
      border: "none",
    },

    paper: ({ theme, ownerState }) => {
      const fallbackColor = "#ffffff";

      // Grab palette and colors from theme
      const palette = theme?.palette || {};
      const colorKey = ownerState?.color || "white";

      // Try to get the correct color
      const mainColor =
        palette[colorKey]?.main ||
        colors[colorKey]?.main ||
        fallbackColor;

      return {
        width: pxToRem(256),
        backgroundColor: mainColor,
        height: `calc(100vh - ${pxToRem(32)})`,
        margin: `${pxToRem(16)} 0 ${pxToRem(16)} ${pxToRem(16)}`,
        borderRadius: borderRadius.xl,
        border: "none",
      };
    },

    paperAnchorDockedLeft: {
      borderRight: "none",
    },
  },
};

export default sidenav;
